@if (formField(); as formField) {
  <div class="password-input">
    <input
      class="password-input__input"
      pInputText
      [formField]="formField"
      [type]="isPasswordShown() ? 'text' : 'password'"
    />
    <span
      class="password-input__toggle"
      (click)="showHidePassword()"
    >
      <svg icon="table-icon-eye" />
    </span>
  </div>
}
